import { createFileRoute, notFound } from "@tanstack/react-router";

import { usePrincipalId } from "../../lib/browser-state";
import { useProject, useProjectId } from "../../shell/project";
import { agentWorkspaceEnabled } from "../../workspaces/agents/availability";
import { ProjectBoardPage } from "../../workspaces/agents/ProjectBoardPage";
import { boardView, type BoardView } from "../../workspaces/agents/board-view";

export const Route = createFileRoute("/_console/p/$org/$project/loop/board")({
  beforeLoad: () => {
    if (!agentWorkspaceEnabled) throw notFound();
  },
  // The open card and the view (`?view=table`; its columns when absent) are the address,
  // so reload, Back and a shared link land on the same board.
  validateSearch: (search: Record<string, unknown>): { readonly card?: string; readonly view?: BoardView } => {
    const view = boardView(search.view);
    return {
      ...(typeof search.card === "string" && /^[0-9a-f-]{36}$/.test(search.card) ? { card: search.card } : {}),
      ...(view === undefined ? {} : { view }),
    };
  },
  component: BoardRoute,
});

/** The project's one board, a page of its own: what needs a person first, then every card. */
function BoardRoute() {
  const projectId = useProjectId();
  const address = useProject().address;
  const principalId = usePrincipalId();
  const { card, view } = Route.useSearch();
  const navigate = Route.useNavigate();
  if (!address) return null;
  return <ProjectBoardPage projectId={projectId} address={address} principalId={principalId}
    selectedCard={card}
    onSelectCard={(next) => void navigate({ search: (previous) => ({ ...previous, card: next }) })}
    view={view}
    onViewChange={(next) =>
      void navigate({ search: (previous) => ({ ...previous, view: next === "columns" ? undefined : next }) })
    }
  />;
}
